<template>
  <div class="Vue-Toastification__toast-component-body">
    <h5 style="margin-bottom: 0rem;" class="toast-notif-header">{{ payloadHeader }}</h5>
    <div class="toast-notif-body d-flex justify-content-between">
      <b-col sm="1" class="mt-3 ms-2">
        <div class="position-relative d-inline-block">
          <i class="mc-fa icon-fill_megaphone fs-2"></i>
          <span class="badge rounded-pill bg-danger text-white position-absolute top-0 end-0"
            >.</span
          >
        </div>
      </b-col>
      <b-col sm="8">
        <b-row>
          <h6>{{ payload.header }}</h6>
        </b-row>
        <b-row>
          <p
            style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis"
            :title="payload.description"
          >
            {{ payload.description }}
          </p>
        </b-row>
      </b-col>
      <b-col sm="1" class="mt-2 me-4">
        <b-button class="btn btn-primary btn-sm text-center" @click="showNotifAction">
          <i class="mc-fa icon-outline_arrow-right fs-4" />
        </b-button>
      </b-col>
    </div>
  </div>
</template>

<script>
import * as systemNotificationUser from '@/services/rest-api-vsms/lib/system-notification/system-notification-user'
import { mapActions } from 'vuex'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  props: {
    payload: {
      type: Object,
      required: true,
    },
    payloadHeader: {
      type: String,
      required: true,
    },
    navbar: {
      required: true,
    }
  },
  mixins: [MixPanel],

  data() {
    return {
      listNotifAction: ['pop_up_image', 'carousel_image', 'pop_up_video'],
    }
  },

  methods: {
    ...mapActions('announcement', ['decrementUnreadAnnouncement']),

    showNotifAction() {
      this.navbar.notifAction = this.payload.action
      this.navbar.notifData = this.payload.data
      this.showDetailAction(this.payload)
      if (!this.payload.is_read) {
        this.updateRead(this.payload.uuid)
      }
      this.mixpanelNotif()
    },

    async showDetailAction(systemNotification) {
      if (this.listNotifAction.includes(systemNotification.action)) {
        this.navbar.$bvModal.show('modal-notif-action')
      } else if (systemNotification.action === 'external_link') {
        window.open(systemNotification.data.data, '_blank')
      } else if (systemNotification.action === 'internal_link') {
        const resolvedUrl = this.navbar.$router.resolve(systemNotification.data.data).href
        window.open(resolvedUrl, '_blank')
      }
    },

    async updateRead(systemNotificationUuid) {
      // read handling
      // document.getElementById(`announcement${systemNotificationUuid}`).classList.remove(`alert-primary`)
      // document.getElementById(`announcement${systemNotificationUuid}`).classList.add(`alert-light`)
      const data = {
        is_read: true,
        updated_on: new Date(),
      }
      if (systemNotificationUuid) {
        await this.decrementUnreadAnnouncement()
        data.system_notification_uuid = systemNotificationUuid
      }
      await systemNotificationUser.update(data)
    },

    mixpanelNotif() {
      this.track('Click System Notif Detail', {
        user_name: this.$store.state.identity.whoami?.name,
        email: this.$store.state.identity.whoami?.email,
        company_name: this.$store.state.identity.whoami?.companyName,
        access_right: this.$store.state.identity.whoami?.accessRight,
      })
    },
  },
}
</script>
